import { render, staticRenderFns } from "./fgd.vue?vue&type=template&id=3917e4c6&scoped=true&"
import script from "./fgd.vue?vue&type=script&lang=js&"
export * from "./fgd.vue?vue&type=script&lang=js&"
import style0 from "./fgd.vue?vue&type=style&index=0&id=3917e4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917e4c6",
  null
  
)

export default component.exports